module.exports = __webpack_public_path__ + "img/sports_therapist.6448c9d6.png";